/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const DELETEEDUCATION= createAsyncThunk(
  "deleteEducation/deleteEducation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteEducationSlice = createSlice({
  name: "deleteEducationSlice",
  initialState: {
    deleteEducation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteEducation: (state) => {
        state.deleteEducation.loading = false
        state.deleteEducation.error = false
        state.deleteEducation.data = []
        state.deleteEducation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEEDUCATION.fulfilled, (state, action) => {
      state.deleteEducation = {
        ...state.deleteEducation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEEDUCATION.pending, (state, action) => {
      state.deleteEducation = {
        ...state.deleteEducation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEEDUCATION.rejected, (state, action) => {
      state.deleteEducation = {
        ...state.deleteEducation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteEducationAction = {
    DELETEEDUCATION,
};

export { deleteEducationAction };
export default deleteEducationSlice.reducer;
export const {setInitialStateOfdeleteEducation} = deleteEducationSlice.actions